import { useEffect, useState, useRef } from "react";
import { useNavigate } from 'react-router-dom';


//react toast 
import { API_SERVER } from "../../EnvConfig/env_config";
import { AlertBox } from "../Common/Input";
import { post } from "../Common/service";


//loder


const ForgotPasswordSlide2 = () => {
    const navigate = useNavigate();
    const inputrefs = useRef([]);
    let url = window.location.search;
    const queryString = new URLSearchParams(url);
    const UserCode = queryString.get('UserCode');
    const Token = queryString.get('Token');

    //initial state
    const [recipe, setRecipe] = useState({ NewPassword: '', ConfirmPassword: '' })
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        document.title = 'Shop4All : Forgot Password'
    }
    , [])

    //Recipe Change Handler
    const HandleChange = (prop, value) => {
        setRecipe(recipe => ({ ...recipe, [prop]: value }))
    }

    //validation handler
    const Validate = () => {
        setErrors({})
        let isValid = true;
        let validation = [
            { field: "NewPassword", msg: 'Please Enter New Password.' },
            { field: "ConfirmPassword", msg: 'Please Enter Confirm Password.' }
        ]


        validation.map(item => {
            if (!recipe[item.field] || recipe[item.field].length <= 0) {
                setErrors(errors => ({ ...errors, [item.field]: item.msg }));
                isValid = false;
            }
            return item;
        });

        if (recipe.NewPassword && recipe.ConfirmPassword) {
            if (recipe.ConfirmPassword !== recipe.NewPassword) {
                setErrors(errors => ({ ...errors, confirm_password_match: 'Confirm Password Not Match' }));
                isValid = false;
            }
        }
        return isValid;
    }

    //submit button Handler
    const HandleSubmit = () => {
            setLoading(true)
            post(`${API_SERVER}/api/UserLogin/UpdateForgotPassword`, { ...recipe, UserCode, Token }, (res) => {
                // console.log(res);
                if (res && res.status) {
                    if (res.status === "SUCESS") {
                        AlertBox(res.status, res.message, res.focus)
                    }
                    if (res.status === "ERROR") {
                        setRecipe(recipe => ({ ...recipe, NewPassword: '', ConfirmPassword: '' }))
                        AlertBox(res.status, res.message, res.focus)
                        setLoading(false)
                    } else {
                        setLoading(false)
                        AlertBox(res.message)
                        navigate('/Login')
                    }
                }
            });
        }

    


    return (
        <>
            {/* Forgot Password Form Start */}
            <div className="container-fluid bg-login" >
                <div className="row  vh-100" data-aos="zoom-in" data-aos-duration="1000" >
                    <div className="col-xl-9 col-md-8 d-flex justify-content-center align-items-center flex-column" style={{ background: 'linear-gradient(45deg, #16625e, #28a892)' }}>
                        <img src="./assets/img/login-bg.svg" style={{ width: '50%' }} alt=''></img>
                        <h2 className="text-white py-4">Welcome Back!</h2>

                    </div>
                    <div className="col-xl-3 col-md-4 px-4 py-5 main-login text-black rounded">
                        <div >
                            <img src="./assets/img/shop4alllogo.png" className='img1' alt="..." style={{ display: "flex", backgroundColor: 'white' }} />

                        </div>
                        <div className="">
                                <h5 className='fs-5 text-center mt-4'><span style={{ color: 'gray', fontWeight: "bold" }}>Forgot</span> <span style={{ color: '#fdb813', fontWeight: "bold" }}>Password</span></h5>


                                <div className="form-group text-start" >
                                    <label className="form-label mb-1">New Password <span className='required'>*</span></label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        id="txtNewPassword"
                                        ref={ref => (inputrefs.current['txtNewPassword'] = ref)}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') { inputrefs.current['txtconfirmPassword'].focus() };
                                        }}
                                        placeholder="New Password"
                                        name='New Password'
                                        value={recipe.NewPassword}
                                        onChange={(e) => HandleChange('NewPassword', e.target.value)}
                                    />

                                    {errors.NewPassword && <div className="error-msg">{errors.NewPassword}</div>}

                                </div>

                                <div className="form-group text-start mb-3" >
                                    <label className="form-label mb-1">Confirm Password <span className='required'>*</span></label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        id="txtconfirmPassword"
                                        ref={ref => (inputrefs.current['txtconfirmPassword'] = ref)}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') { inputrefs.current['btnSubmit'].focus() };
                                        }}
                                        placeholder="Confirm Password"
                                        name='Confirm Password'
                                        value={recipe.ConfirmPassword}
                                        onChange={(e) => HandleChange('ConfirmPassword', e.target.value)}
                                    />

                                    {errors.ConfirmPassword && <div className="error-msg">{errors.ConfirmPassword}</div>}
                                    {errors.confirm_password_match && <div className="error-msg">{errors.confirm_password_match}</div>}
                                </div>

                                <button
                                    ref={ref => (inputrefs.current['btnSubmit'] = ref)}
                                    className='btn-primary btn w-100'
                                    onClick={HandleSubmit}
                                >
                                    Update Password
                                </button>
                        </div>
                    </div>
                </div>
            </div>
            {/* Forgot Password Form End */}

            {/* Loder start*/}
          
            {/* Loder End*/}
        </>

    )
}

export default ForgotPasswordSlide2;
